import React, {useContext} from 'react';
import PageContext from "../../contexts/Page";
import {InView} from "react-intersection-observer";

// components
import Page from '../../components/Page';
import HomeSection from "../../components/HomeSection";
import SliderSection from "../../components/Sections/SliderSection";
import Team from "../../components/Sections/Team";
import OurWorks from "../../components/Sections/OurWorks";
import CashRebate from "../../components/Sections/CashRebate";
import Locations from "../../components/Sections/Locations";
import Philosophy from "../../components/Sections/Philosophy";
import Partner from "../../components/Sections/Partner";

//styles
import "./Home.scss";


const Home = () => {

	const {pageData} = useContext(PageContext);

	const {
		cash_diagram,
		cash_tekst,
		cash_tytul_sekcji,
		cash_sekcja_zwijalna,
		cash_wys_sekcji,
		czlonkowie_teamu,
		locations_tytul_sekcji,
		locations_tekst,
		locations_obraz,
		locations_parallax,
		ourworks_tytul_sekcji,
		partner_slogan,
		partner_obraz_tla,
		philosophy_tytul,
		slajder,
		team_tytul_sekcji,
		team_tytul_sekcji_mobile,
		zasady
	} = pageData;
	return (
		<Page>
			<HomeSection>
				<SliderSection slides={slajder}/>
			</HomeSection>
			<HomeSection>
				<Team
					team={czlonkowie_teamu}
					sectionTitle={{desktop:team_tytul_sekcji,mobile:team_tytul_sekcji_mobile}}/>
			</HomeSection>
			<HomeSection>
				<OurWorks sectionTitle={ourworks_tytul_sekcji}/>
			</HomeSection>
			<HomeSection>
				<CashRebate
					sectionTitle={cash_tytul_sekcji}
					txt={cash_tekst}
					diagram={cash_diagram}
					expandable={cash_sekcja_zwijalna}
					size={cash_wys_sekcji}
				/>
			</HomeSection>
			<HomeSection>
				<Partner bg={partner_obraz_tla} slogan={partner_slogan}/>
			</HomeSection>
			<HomeSection>
				<Locations
					sectionTitle={locations_tytul_sekcji}
					txt={locations_tekst}
					poster={locations_obraz}
					parallaxLayers={locations_parallax}
				/>
			</HomeSection>
			<HomeSection>
				<InView>
					{({ inView, ref }) => (
						<div ref={ref}>
							<Philosophy
								sectionTitle={philosophy_tytul}
								rules={zasady}
								inView={inView}
							/>
						</div>
					)}
				</InView>
			</HomeSection>
		</Page>
	);
};

export default Home;

